module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-touch', {
    staticClass: "day-cal__overlay"
  }, [_c('div', {
    staticClass: "days-container",
    style: ({
      height: _vm.height + 'px'
    })
  }, [_c('full-calendar', {
    attrs: {
      "caldate": _vm.date,
      "events": _vm.lessons,
      "viewState": _vm.viewState,
      "locale": _vm.locale,
      "i18n": _vm.i18n
    },
    on: {
      "eventclick": _vm.onTap
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pad-10 weekplan-header marg-20-top"
  }, [_c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.calRangeView))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('calendars.week_plan_and_note.week_plan')))])]), _vm._v(" "), _c('weekplan', {
    staticClass: "pad-10",
    attrs: {
      "weeknote": _vm.weeknote,
      "calId": _vm.calId,
      "date": _vm.date,
      "events": _vm.lessons
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03156f74!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Mobile/WeekCal/CalContainer.vue
// module id = 1487
// module chunks = 1